/**
 * Recognise the various shapes of "request was cancelled" we get back
 * from native fetch (DOMException 'AbortError') and axios
 * (CanceledError / code 'ERR_CANCELED'). useEffect cleanups should
 * silently ignore these so cancellation doesn't surface as an error.
 */
export function isAbortError(err: unknown): boolean {
  if (!err || typeof err !== 'object') return false;
  const e = err as { name?: string; code?: string };
  return (
    e.name === 'AbortError' ||
    e.name === 'CanceledError' ||
    e.code === 'ERR_CANCELED'
  );
}
